module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 258
// module chunks = 13